export default "__VITE_ASSET__D8sjqac6__"